/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import Iframe from 'react-iframe'
import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  Col,
  Container,
  Row
} from "shards-react";
import MetaTags from 'react-meta-tags';
import PageTitle from "../components/common/PageTitle";
import { RWebShare } from "react-web-share";
import Countdown from "react-countdown";
import Moment from "moment";

class JetsoPost extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      JetsoList: [],
      showIframe: false,
      isLoading: false,
      isOpenNewPage: true
    };
  }

  async componentDidMount() {
    const dataSet = await fetch("https://jetsohub-seo.gitlab.io/database/master_data_set.json",
      { headers: {'Content-Type': 'application/json'}}
    ).then(res => res.json())
    this.setState({JetsoList: dataSet})

    const item = this.state.JetsoList.find(item=>item.uuid == this.props.uuid );

    this.setState({isLoading: true})
    //TODO : way to check if cors can be catched
    if(['hket', 'jetsotoday'].indexOf(item.source) >= 0){

    }else{
      this.setState({showIframe: true})
    }

    this.setState({isLoading: false})
    // fetch(item.url)
    //   .then(
    //     (result) => {
    //       console.log("ok to load iframe")
    //       this.setState({showIframe: true})
    //     },
    //     (error) => {
    //       console.log("failed to load iframe... redirect to link")
    //       this.setState({showIframe: false})
    //       // setTimeout(function(){
    //       //   window.location.href = item.url;
    //       // }, 5000);
    //     }
    //   ).then(()=>{
    //   this.setState({isLoading: false})
    // })
  }

  render() {
    if(this.state.JetsoList.length <=0) return null;

    const item = this.state.JetsoList.find(item=>item.uuid == this.props.uuid );
    if(item == null){
      return <Container fluid className="main-content-container px-4">
      <p>Not found</p>
      </Container>
    }
    const renderer = ({ hours, minutes, seconds, completed }) => {
      if (completed) {
        // Render a completed state
        // window.location.href = item.url;
        if(this.state.isOpenNewPage){
          window.open(
            item.url, "_blank");
        }
        return <span>己打開</span>;
      } else {
        // Render a countdown
        return <span>將於{seconds}秒後為你打開</span>;
      }
    };

    const handleClick = (e)=>{
      console.log("open new url/page detected")
      console.log("stop open new page")

      this.state.isOpenNewPage = false
    }
    return (
      <Container fluid className="main-content-container px-4" style={{height:"100%"}}>
        <MetaTags>
            <meta property="og:title" content={item.title} />
            <meta property="og:image" content={item.image} />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:description" content={item.title} />
            <meta property="og:site_name" content="JetsoHub 著數盒子"/>
            <meta property="og:type" content="article"/>
            <title>{item.title + "| JetsoHub 著數盒子"}</title>
        </MetaTags>
        <Row noGutters className="page-header py-4">
          <Col lg="10">
            <a href="/"> <span>主頁</span></a>
            &nbsp;
            <span>/</span>
            &nbsp;
            <span>{item.title}</span>
          </Col>
          <Col lg="2">
          <div>
            <RWebShare
              data={{
                text: item.title,
                url: "https://jetsohub-seo.gitlab.io/seo/" + item.uuid + ".html",
                title: "分享文章",
              }}
              onClick={() => console.log("shared successfully!")}
            >
              <button><span>分享文章</span></button>
            </RWebShare>
            <span>  </span>
            <a href={item.url} target="_blank" rel="noopener noreferrer" ><button><span>進入網站</span></button></a>
          </div>
          </Col>
          {/*<PageTitle sm="12" subtitle={item.title} className="text-sm-left" />*/}
        </Row>

        {
          this.state.showIframe && !this.state.isLoading &&
          <><h6 style={{"text-align": "center"}}>安全預覽中, <a href={item.url} target="_blank" rel="noopener noreferrer" onClick={handleClick}>如無法顯示, 可直接進入網站</a></h6>
          <Iframe url={item.url}
                                width="100%"
                                height="100%"
                                // id="myId"
                                // className="myClassname"
                                onLoad={(e) => {
                                  // console.log("loaded");
                                  // console.log(e)
                                }}
                                onError={() => console.log("failed to load")}
                                display="initial"
                                position="relative"/></>
        }

        {
          !this.state.showIframe  && !this.state.isLoading &&
          <>
            <p style={{"text-align": "center"}}>安全預覽中, <a href={item.url} target="_blank" rel="noopener noreferrer" onClick={handleClick}>如無法顯示, 可直接進入網站</a></p>
            <p style={{"text-align": "center"}}><Countdown date={Date.now() + 10000} renderer={renderer} /></p>
            <Col lg="12" md="12" sm="12" className="mb-12" key={1}>
              <Card small className="card-post h-100">
                <a href={item.url} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
                  <div
                    className="card-post__image"
                    style={{backgroundImage: (item.image_self_hosted == true ? `url(https://jetsohub-seo.gitlab.io/image/${item.uuid}.jpg)` : (item.image ? 'url(' + item.image + ')' : `url("https://blogger.googleusercontent.com/img/a/AVvXsEjEDWA7ICCKL7EeKFPGF9uHKT8ygnn9B_bVarniKIxTIcNcC4_4wJdpE-MBvRVPHhw_UCZYOAt8IP0cCsRuoDJvggR7h_TloNfE225BYfSshKkOQYbc5oaITLjqwwFut8UYcEABHtoXDESCvz1-KVjdpGG-DuG0AQYUiwBAqn8lhxHm04Bz_HjDBBT2uA=s0")`))
                        + `, url(${process.env.PUBLIC_URL}/icon.svg)`}}
                  />
                </a>
                <CardBody>
                  <h5 className="card-title">
                    <a className="text-fiord-blue" href={item.url} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
                      {item.title}
                    </a>
                  </h5>
                </CardBody>
                <CardFooter>
                  <span className="text-muted">{Moment.utc(item.created_date).isSame(new Date(), "day") ?  "今天 " + Moment.utc(item.created_date).utcOffset("+08:00").format('Ah點').replace("AM", "上午").replace("PM", "下午") : Moment.utc(item.created_date).utcOffset("+08:00").format('DD MMM YYYY')}</span>
                </CardFooter>
              </Card>
            </Col>
          </>
        }

        {
          this.state.isLoading  && <p>努力加載中...</p>
        }

      </Container>
    );
  }
}

export default JetsoPost;
